exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0;padding:0;list-style:none}.social__item:not(:last-of-type){margin-right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/home/vintagt/www/toyota/toyota.com/dreamcar/front/assets","/static":"/home/vintagt/www/toyota/toyota.com/dreamcar/front/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4281d3c6","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/home/vintagt/www/toyota/toyota.com/dreamcar/front/assets/scss/util/_mixins.scss","/home/vintagt/www/toyota/toyota.com/dreamcar/front/assets/scss/util/_functions.scss","/home/vintagt/www/toyota/toyota.com/dreamcar/front/assets/scss/util/_variables.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/SocialList.vue
// module id = PiJF
// module chunks = 3 4